// 专属权益
import { RootObject, Content2, DescContent } from '../../type';
import './style.less';

const ExclusiveInterest = (props: RootObject["exclusiveInterest"]) => {
  const {
    zhTitle,
    enTitle,
    content
  } = props;
  return (
    <div className='p-p-foundathon-exclusiveInterest'>
      <div className='p-p-foundathon-exclusiveInterest-zh-title'>
        {
          zhTitle ?? ''
        }
      </div>
      <div className='p-p-foundathon-exclusiveInterest-en-title'>
        {
          enTitle ?? ''
        }
      </div>
      <div className='p-p-foundathon-exclusiveInterest-modules'>
        {
          content.map((item: Content2, index: number) => {
            return (
              <div className='p-p-foundathon-exclusiveInterest-modules-module' key={index}>
                <div className='p-p-foundathon-exclusiveInterest-modules-module-back'>
                  <img src={item.titleImg} alt="" className='p-p-foundathon-exclusiveInterest-modules-module-back-img' />
                </div>
                <div className='p-p-foundathon-exclusiveInterest-modules-module-title'>
                  {
                    item.title ?? ''
                  }
                </div>
                <div className='p-p-foundathon-exclusiveInterest-modules-module-descs'>
                  {
                    item.descContent.map((el: DescContent, i: number) => {
                      return (
                        <div className='p-p-foundathon-exclusiveInterest-modules-module-descs-desc' key={i}>
                          {
                            el.desc ?? ''
                          }
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default ExclusiveInterest